const COLOR_CLASSES = {
  fern: 'bg-fern-100 border-fern text-fern-dark',
  moana: 'bg-moana-50 border-moana text-moana-dark',
  kowhai: 'bg-kowhai-50 border-kowhai-dark text-kowhai-dark',
  kereru: 'bg-kereru-50 border-kereru text-kereru-dark',
};

export default function ActivityBlock({ item, onClick }) {
  const colorClass = COLOR_CLASSES[item.color] || COLOR_CLASSES.fern;
  return (
    <button
      onClick={onClick}
      data-testid={`activity-block-${item.id}`}
      className={`w-full text-left rounded-lg border-l-4 px-2.5 py-1.5 text-xs ${colorClass} ${item.completed ? 'opacity-50 line-through' : ''} hover:brightness-95 transition`}
    >
      <div className="font-semibold truncate">{item.title}</div>
      <div className="opacity-70">{item.start_time}–{item.end_time}</div>
    </button>
  );
}
